import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { Credential } from '../model/User';
import { Observable } from 'rxjs';
import { TaskStatus } from '../model/TaskStatus';
import { delay } from 'rxjs/operators';

export class UserResponse {
    count: number;
    users: Credential[];
}

export class OTDSUser {
    givenName: string;
    id: string;
    surname:string;
  }
  
@Injectable({
    providedIn: 'root'
})
export class UserService {
    private url: string

    constructor(private http: HttpClient, private authService: AuthenticationService) {
        this.url = "/services/otsc-server/v1/managers/user/";
    }

    listUsers(pageSize: number, startIndex: number, query: string) {
        let url = this.url + "listAllUsers";
        let params = new HttpParams().set('pageSize', pageSize.toString())
                                     .set('startIndex', startIndex.toString())
                                     .set('query', query ? query : '');

        return this.http.get<UserResponse>(url,
            {
                observe: 'response',
                params: params
            });
    }

    updateUser(newUserName: string, userName: string, firstName: string, lastName: string,
        newPassword: string, role: string, envList: number[], solList: string[], userId: number): any {
        let url = this.url + "updateUser";
        const body = new URLSearchParams();
        body.set('newUserName', newUserName);
        body.set('userName', userName);
        body.set('firstName', firstName);
        body.set('lastName', lastName);
        body.set('newPassword', newPassword);
        body.set('role', role);
        if (envList) {
            envList.forEach(env => {
                body.append('envList[]', env.toString());
            });
        }
        if (solList) {
            solList.forEach(sol => {
                body.append('solList[]', sol);
            });
        }
        body.set('userId', userId.toString());

        return this.http.post<any>(url,
            body.toString(),
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                observe: 'response'
            });
    }

    removeUsers(userNames: string[]): Observable<HttpResponse<boolean>> {
        let url = this.url + "deleteUsers";
        let body = new URLSearchParams();

        userNames.forEach((username: string) => {
            body.append('userNames[]', username);
        });

        return this.http.post<boolean>(url,
            body.toString(),
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                observe: 'response',
            }
        );
    }

    unlockAccount(userName: string): Observable<HttpResponse<TaskStatus>> {
        let url = this.url + "account";

        return this.http.post<TaskStatus>(url,
            undefined,
            {
                observe: 'response',
                params: { userName: userName }
            }
        );
    }

    createUser(userName: string, firstName: string, lastName: string,
        newUserPassword: string, newUserVerifyPassword: string, role: string,
        envList: number[], solList: string[]): any {
        let url = this.url + "createUser";
        const body = new URLSearchParams();
        body.set('userName', userName);
        body.set('firstName', firstName);
        body.set('lastName', lastName);
        body.set('newUserPassword', newUserPassword);
        body.set('newUserVerifyPassword', newUserVerifyPassword);
        body.set('role', role);
        envList.forEach(env => {
            body.append('envList[]', env.toString());
        });
        solList.forEach(sol => {
            body.append('solList[]', sol);
        });

        return this.http.post<any>(url,
            body.toString(),
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                observe: 'response'
            });
    }

    searchOTDSUsers(query: string): Observable<HttpResponse<OTDSUser[]>> {
        
        return this.http.get<OTDSUser[]>(this.url + "searchOTDSUsers",
        {
            observe: 'response',
            params: {
                query: query
            }
        }).pipe();
    }
}